export function MaybeThisSoundsFamiliar() {
  return (
    <section data-testid="cc-maybe-familiar-section" className="relative overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[52px] md:pb-[72px] pb-[56px] md:pt-[72px] reveal">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
            Maybe This Sounds Familiar
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.1] tracking-tight text-[#1C1917] mb-8">
            You meant to keep going.
          </h2>

          <div className="space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-xl">
            <p>You started with the best intentions.</p>
            <p>Then life happened.</p>
            <p>
              Work got busy. Someone needed you. A deadline moved. You missed
              a few days and somehow a few days became a few months.
            </p>
            <p>It wasn&rsquo;t because your dream stopped mattering.</p>
            <p>It was because the urgent quietly replaced the important.</p>
            <p>
              Little by little, you lost touch with the thing you were trying
              to build, change or become.
            </p>
            <p>Not because you failed.</p>
            <p>Because there was nothing helping you return.</p>
          </div>

          <div className="mt-10 space-y-1">
            <p className="font-display text-2xl md:text-3xl text-[#57534E] leading-snug">
              Maybe you don&rsquo;t need more discipline.
            </p>
            <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug">
              Maybe you just need somewhere to come back.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
